export const parsedNumber = (value = "") => {
    return parseFloat(
      value
        .replace(/[^0-9.,-]+/g, "")
        .replace(".", "")
        .replace(",", ".")
    );
  };